module.exports = __webpack_public_path__ + "static/media/logo_mobile.8b07f565.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_mobile.svg
// module id = 49
// module chunks = 0